/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gdpr_Col_WhenInputs */

const cs_gdpr_col_when = /** @type {(inputs: Gdpr_Col_WhenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kdy`)
};

const en_gdpr_col_when = /** @type {(inputs: Gdpr_Col_WhenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`When`)
};

/**
* | output |
* | --- |
* | "When" |
*
* @param {Gdpr_Col_WhenInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const gdpr_col_when = /** @type {((inputs?: Gdpr_Col_WhenInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gdpr_Col_WhenInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gdpr_col_when(inputs)
	return cs_gdpr_col_when(inputs)
});